import { observe } from 'mobx';
import { Provider, inject, observer } from 'mobx-react';
import React from 'react';

import { LicenseObservable } from 'bz-stores/lib/licence';

import ProntoCache from 'bz-pronto-core/cache';
import prontoRegister from 'bz-pronto-core/register';
import { cache } from 'tm3-core/cache';
import tm3payRegister from 'tm3-pay/register';
cache.app.plugin(
  () => cache.app.NH,
  async () => cache.app.register((await import('nuffield-bespoke/register')).default)
);

@inject('prontoCache')
@observer
class License extends React.Component<any, any> {
  dispose: any;

  constructor(props: any) {
    super(props);

    cache.app.register(tm3payRegister);

    const { prontoCache } = props;

    let { license } = LicenseObservable;

    this.dispose = observe(license, (res: any) => {
      let { name, newValue } = res;
      if (name === 'hasOnlineReferralBookings' && !!newValue) {
        ProntoCache.onConfigure().then((x) => {
          cache.app.register(prontoRegister);
        });
      }
    });
  }

  render() {
    let { license } = LicenseObservable;

    return <Provider license={license}>{this.props.children}</Provider>;
  }

  componentWillUnmount() {
    if (!!this.dispose) {
      this.dispose();
    }
  }
}

export default License;
